<template>
  <div id="top">
    <div class="image_birds">
      <div :class="image_bg"></div>
    </div>
    <ContentHeader class="content" />

    <div class="searchBar">
      <v-container class="my-5">
        <v-layout row justify-center>
          <v-flex xs8 sm8 md6 lg6>
            <v-layout row>
            <v-combobox
              v-model="selectedSpecies"
              :label="$t('searchBar')"
              :items="speciesList"
              :hide-selected="true"
              :multiple="true"
              :small-chips="true"
              :clearable="true"
              :deletable-chips="true"
            ></v-combobox>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </div>

    <div class="photos">
      <v-container class="my-5">
        <v-layout row wrap justify-center>
          <v-flex xs10 sm10 md2 lg2 v-for="item2 in selectedSpeciesDisplay" :key="item2.id">
            <v-hover v-slot:default="{ hover }">
              <router-link :to="{ name: 'ViewPhotos', params: { species: item2}}">
                <div v-if="!optimize">
                <v-card class="ml-1 mt-1 mr-1" tile>
                  
                    <v-img :src="speciesDict[item2][0]" :aspect-ratio="16/9">
                    <v-expand-transition>
                      <div
                        v-if="hover"
                        class="d-flex black darken-1 v-card--reveal white--text"
                        style="height:100%"
                      >{{item2}}</div>
                    </v-expand-transition>
                    </v-img>
                  
                </v-card>
                </div>
                  <div v-else>
                    <v-card height="50px">
                    <v-card-text class="card-text">{{item2}}</v-card-text>
                    </v-card>
                  </div>
              </router-link>
            </v-hover>
          </v-flex>
        </v-layout>
      </v-container>
      <Footer class="footer" />
    </div>
  </div>
</template>

<script>
import ContentHeader from "../components/ContentHeader.vue";
import Footer from "../components/Footer.vue";
import axios from "axios";
export default {
  name: "ViewSpecies",
  data() {
    return {
      selectedSpecies: [],
      lang: this.$route.params.lang,
      speciesDictNL: {},
      speciesDictEN: {},
      speciesListNL: [],
      speciesListEN: [],
      optimize: false,
    };
  },
  components: {
    ContentHeader,
    Footer
  },
  props: {
    animal: String
  },
  methods: {
    updateLang() {
      this.lang = this.$route.params.lang;
    }
  },
  watch: {
    $route: "updateLang"
  },
  computed: {
    selectedSpeciesDisplay() {
      if (this.selectedSpecies.length == 0) {
        if(this.lang == 'en'){
          return this.speciesListEN;
        }else{
          return this.speciesListNL;
        }
      }
      return this.selectedSpecies;
    },
    image_bg() {
      if (this.animal == "bird") {
        return "image_birds_bg";
      }
      return "image_mammal_bg";
    },
    speciesList(){
      if(this.lang=="en"){
        return this.speciesListEN
      }
      return this.speciesListNL
    },
    speciesDict(){
      if(this.lang=="en"){
        return this.speciesDictEN
      }
      return this.speciesDictNL
    }
  },
  mounted() {
    if(this.animal == 'bird'){
      axios
      .get("https://pascaldemunckbackend.com/api/photos/1/getBirdSpeciesList/")
      .then(res => {
        this.speciesDictNL = res.data[0];
        this.speciesDictEN = res.data[1];
        this.speciesListNL = res.data[2];
        this.speciesListEN = res.data[3];
      })
      .catch(err => console.log(err.response));
    }else{
      axios
      .get("https://pascaldemunckbackend.com/api/photos/1/getMammalSpeciesList/")
      .then(res => {
        this.speciesDictNL = res.data[0];
        this.speciesDictEN = res.data[1];
        this.speciesListNL = res.data[2];
        this.speciesListEN = res.data[3];
      })
      .catch(err => console.log(err.response));
    }
    
  }
};
</script>

<style scoped>
.footer {
  position: absolute;
  width: 100%;
}

.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.5;
  position: absolute;
  width: 100%;
}

.photos {
  width: 100%;
  position: absolute;
  top: 60%;
}

.searchBar {
  width: 100%;
  margin-bottom: 10px;
  position: absolute;
  top: 52%;
}

.image_birds {
  height: 55vh;
  width: 100%;
}

.image_birds_bg {
  width: 100%;
  height: 100%;
  background-image: url("../assets/birds_header.jpg");
  background-attachment: fixed;
  background-size: cover;
  background-position: center;
}

.image_mammal_bg {
  height: 100%;
  width: 100%;

  background-image: url("../assets/mammal_header.jpg");
  background-attachment: fixed;
  background-size: cover;
  background-position: center;
}

.card-text {
  text-decoration: none;
  margin-top: 20px;
  
}
</style>